export default {
  methods: {
    async addRippleOnBtnClick (e) {
      // Ripple эффект
      const button = e.currentTarget
      const rect = button.getBoundingClientRect()

      const circle = document.createElement('span')
      const diameter = Math.max(button.clientWidth, button.clientHeight)
      const radius = diameter / 2

      // Координаты клика относительно кнопки
      const x = e.clientX - rect.left - radius
      const y = e.clientY - rect.top - radius

      circle.style.width = circle.style.height = `${diameter}px`
      circle.style.left = `${x}px`
      circle.style.top = `${y}px`
      circle.classList.add('ripple')

      // удаляем предыдущую волну если есть
      const oldRipple = button.querySelector('.ripple')
      if (oldRipple) oldRipple.remove()

      button.appendChild(circle)

      // удалить после завершения анимации
      setTimeout(() => circle.remove(), 600)
    }
  }
}



// WEBPACK FOOTER //
// ./src/vue/common/mixins/ui.mixin.js